"use client";

import React from "react";
import { DrawerContext } from "./context";
import type { DrawerProviderProps } from "./types";

function DrawerProvider({
  direction = "right",
  children,
}: DrawerProviderProps) {
  const context = React.useMemo(() => ({ direction }), [direction]);

  return (
    <DrawerContext.Provider value={context}>{children}</DrawerContext.Provider>
  );
}

export default DrawerProvider;
